import { render, staticRenderFns } from "./BusinessFrontPageExternalLinksSummaryCard.vue?vue&type=template&id=ad4dd514&scoped=true&"
import script from "./BusinessFrontPageExternalLinksSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./BusinessFrontPageExternalLinksSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessFrontPageExternalLinksSummaryCard.vue?vue&type=style&index=0&id=ad4dd514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4dd514",
  null
  
)

export default component.exports